import Lookup from './lookup.js';

export default class Category extends Lookup
{
    
}
